import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      website: "https://glass-railing.com",
      aboutWebsite: "https://glass-railing.com",
      contactWebsite: "https://glass-railing.com/contact",
      firstStep: "First Step",
      chooseProvince: "Choose the Province",
      chooseTheHeightOfGlass: "Choose the Height of the Glass",
      chooseTheColor: "Choose the color",
      chooseTheSizeOfTheProject: "Choose the Size of the Project",
      small: "Small",
      medium: "Medium",
      large: "Large",
      phone: "Phone",
      address: "Address",
      name: "Name",
      companyAddress: "67 Westmore Dr Unit 19-20,",
      companyAddress2: "Etobicoke, ON M9V 3Y6",
      companyPhoneNumber: "(647) 740-4552",
      companyEmail: "info@glass-railing.com",
      glass: "Glass",
      pricePerUnit: "Price per Unit",
      quantity: "Quantity",
      quotationNumber: "Quotation Number",
      print: "Print",
      includeConnectors: "Add Connectors",
      removeConnectors: "Remove Connectors",
      contact: "Contact",
      about: "About"
      // Add more English translations here
    },
  },
  fr: {
    translation: {
      website: "https://www.cloture-en-verre.com",
      aboutWebsite: "https://cloture-verre.com/guides/bc-transparant",
      contactWebsite: "https://cloture-verre.com/contact",
      firstStep: "Première étape",
      chooseProvince: "Choisir la province",
      chooseTheHeightOfGlass: "Choisir la hauteur du la cloture",
      chooseTheColor: "Choisir la couleur",
      chooseTheSizeOfTheProject: "Choisir la grandeur",
      small: "Petit",
      medium: "Moyen",
      large: "Grand",
      phone: "Téléphone",
      address: "Adresse",
      name: "Nom",
      companyAddress: "1446 rue Michelin, Laval",
      companyAddress2: "Etobicoke, ON M9V 3Y6,",
      companyPhoneNumber: "(514) 447-0999",
      companyEmail: "info@cloture-verre.com",
      glass: "Verre",
      pricePerUnit: "Prix unitaire",
      quantity: "Quantité",
      quotationNumber: "Soumission",
      print: "Imprimer",
      includeConnectors: "Attaches inclus",
      removeConnectors: "Attaches non inclus",
      contact:"Contactez Nous",
      about: "Notre Histoire"
      // Add more French translations here
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang") || "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
